var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTask({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#2064B0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checklist",
    transform: "translate(-343 -243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(343 243)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    className: "st0",
    d: "M44.7,4.2v41.7c0,2-1.6,3.6-3.6,3.6l0,0H8.9c-2,0-3.6-1.6-3.6-3.6l0,0V4.2c0-2,1.6-3.6,3.6-3.6 l0,0h32.5C43.2,0.6,44.7,2.1,44.7,4.2L44.7,4.2z M22.8,40h16.1c0.7,0,1.1-0.4,1.1-1.1s-0.4-1.1-1.1-1.1H22.8 c-0.7,0-1.1,0.4-1.1,1.1S22.1,40,22.8,40z M10.2,37.3l2.2,2.2c0.4,0.4,1.1,0.4,1.6,0l0,0l4.7-4.7c0.4-0.4,0.4-1.1,0-1.6 c-0.4-0.4-1.1-0.4-1.6,0l0,0l-3.8,3.8L12,35.8c-0.4-0.4-1.1-0.4-1.6,0C9.8,36.2,9.8,36.9,10.2,37.3L10.2,37.3L10.2,37.3z  M22.8,35.3h16.1c0.7,0,1.1-0.4,1.1-1.1s-0.4-1.1-1.1-1.1H22.8c-0.7,0-1.1,0.4-1.1,1.1S22.1,35.3,22.8,35.3z M22.8,28.4h16.1 c0.7,0,1.1-0.4,1.1-1.1c0-0.7-0.4-1.1-1.1-1.1H22.8c-0.7,0-1.1,0.4-1.1,1.1C21.6,27.9,22.1,28.4,22.8,28.4L22.8,28.4z M10.2,25.7 l2.2,2.2c0.4,0.4,1.1,0.4,1.6,0l0,0l4.7-4.7c0.4-0.4,0.4-1.1,0-1.6c-0.4-0.4-1.1-0.4-1.6,0l0,0l-3.8,3.8L12,24.1 c-0.4-0.4-1.1-0.4-1.6,0C9.8,24.6,9.8,25.2,10.2,25.7L10.2,25.7z M22.8,23.9h16.1c0.7,0,1.1-0.4,1.1-1.1s-0.4-1.1-1.1-1.1H22.8 c-0.7,0-1.1,0.4-1.1,1.1C21.6,23.2,22.1,23.9,22.8,23.9z M22.8,16.9h16.1c0.7,0,1.1-0.4,1.1-1.1s-0.4-1.1-1.1-1.1H22.8 c-0.7,0-1.1,0.4-1.1,1.1C21.6,16.3,22.1,16.9,22.8,16.9z M10.2,14.2l2.2,2.2c0.4,0.4,1.1,0.4,1.6,0l0,0l4.9-4.7 c0.4-0.4,0.4-1.1,0-1.6c-0.4-0.4-1.1-0.4-1.6,0l0,0l-4,3.8L12,12.5c-0.4-0.4-1.1-0.4-1.6,0C9.8,13.1,9.8,13.8,10.2,14.2L10.2,14.2 z M22.8,12.2h16.1c0.7,0,1.1-0.4,1.1-1.1S39.6,10,38.9,10H22.8c-0.7,0-1.1,0.4-1.1,1.1S22.1,12.2,22.8,12.2L22.8,12.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.66614e662acd772e3f587ec67e1c603b.svg";
export { ForwardRef as ReactComponent };